module.exports = __webpack_public_path__ + "13d44aa6657bd933bebdf6fdf955201c.png";